<template>
  <div>
    <loader v-if="loader"/>

    <b-row>
      <b-col class="text-muted">
        <b-row>
          <b-col
              v-for="(input, index) in mainInputs"
              :key="`${index}${input.name}`"
              :xl="input.columns"
              md="4"
              class="mb-4">
            <b-input-group class="flex-column">
              <label class="d-block" :for="input.id">{{ input.label }}</label>
              <div class="position-relative">
                <b-form-input
                    class="rounded"
                    v-if="input.type === 'text'"
                    v-model="filterObject[input.name]"
                    :placeholder="input.placeholder"
                    :name="input.name"
                    :id="input.id"
                    @input="value => {debounceFilter(input.name, value)}"
                    @keyup.enter="applyOnEnter(input.name)"
                    autocomplete="off"
                />
              </div>

              <multiselect
                  v-if="input.type === 'select' && !input.group"
                  v-model="filterObject[input.name]"
                  :multiple="input.multiple"
                  :id="input.name"
                  label="label"
                  track-by="value"
                  :placeholder="input.placeholder"
                  :options="input.options"
                  :searchable="input.searchable"
                  :allow-empty="input.allow_empty"
                  :close-on-select="!input.multiple"
                  @select="value => {debounceFilter(input.name, value, input.multiple)}"
                  @remove="value => {debounceFilter(input.name, value, input.multiple, true)}"
                  @search-change="query => {debounceGetSelectOptions(input.options_url, input.name, input.filter_field, query)}"
                  select-label=""
                  selected-label=""
                  deselect-label="X ">
                <template slot="noResult">
                  {{$t('global.no_results')}}
                </template>
              </multiselect>

              <group-select
                  :show-label="false"
                  v-if="input.type === 'select' && input.group"
                  :input="input"
                  :model="filterObject[input.name]"
                  @select="filter"
                  @remove="filter"
                  :group-select="input.groupSelect"
                  :key="`grp-main-${input.name}-${resetKey}`"
              />

            </b-input-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="d-flex mb-4 flex-column flex-md-row align-items-center justify-content-center justify-content-md-between">
            <div v-if="manualApply" class="mb-2 d-flex align-items-center">
              <b-button
                  variant="primary"
                  class="px-4 mr-2"
                  @click="applyFilters"
                  :disabled="filterActionsDisabled"
              >Apply</b-button>
              <b-button
                  variant="outline-primary"
                  class="px-4"
                  @click="clearAll"
                  :disabled="filterActionsDisabled"
              >Clear All</b-button>
            </div>
            <b-button
                v-if="extendButton"
                class="px-4  mb-2"
                variant="outline-primary"
                @click="extend = !extend; "
                :disabled="disableInput('button')"
            >{{ !extend ? 'Show advanced filters' : 'Hide advanced filters' }}
            </b-button>
          </b-col>
        </b-row>
        <b-row v-if="extend">

          <b-col>

            <b-row>
              <b-col class="mb-4"
                     :md="inputsWidth"
                     v-for="(input, index) in inputsText"
                     :key="`${index}${input.name}`">
                <b-input-group class=" flex-column">

                  <label
                      class="d-block"
                      v-if="input.label"
                      :for="input.id"
                  >{{ input.label }}</label>

                  <b-form-input
                      class="rounded"
                      v-model="filterObject[input.name]"
                      :placeholder="input.placeholder"
                      :disabled="disableInput(input.name)"
                      :name="input.name"
                      :id="input.id"
                      autocomplete="off"
                      @input="value => {debounceFilter(input.name, value)}"
                      @keyup.enter="applyOnEnter(input.name)"
                  />

                </b-input-group>

              </b-col>

              <b-col class="mb-4"
                     :md="inputsWidth"
                     v-for="(input, index) in priceRanges"
                     :key="`${index}${input.name}`">
                <label
                    class="d-block"
                    v-if="input.label"
                    :for="input.id"
                >{{ input.label }}</label>
                <b-row>
                  <b-col
                      v-for="(option, index) in input.options"
                      :key="`${index}${input.name}`"
                  >
                    <b-input-group class="flex-column">
                      <money v-model="filterObject.range[option.name]"
                             :disabled="disableInput(option.name)"
                             @input="value => {debounceFilter(`${input.name} ${option.name}`, value, false, false, true)}"
                             :placeholder="option.placeholder"
                             v-bind="money"
                             class="rounded">
                      </money>
                    </b-input-group>
                  </b-col>
                </b-row>

              </b-col>

              <b-col
                  :md="inputsWidth"
                  class=" flex-column mb-4"
                  v-for="(input, index) in selects"
                  :key="`${index}${input.name}`"
                  v-if="selectOptions[input.name]"
              >

                <label
                    class="d-block"
                    v-if="input.label"
                    :for="input.id">{{ input.label }}</label>

                <multiselect
                    v-model="filterObject[input.name]"
                    :multiple="input.multiple"
                    :id="input.name"
                    label="label"
                    track-by="value"
                    :placeholder="input.placeholder"
                    :options="selectOptions[input.name]"
                    :searchable="input.searchable"
                    :allow-empty="input.allow_empty"
                    :close-on-select="!input.multiple"
                    :disabled="disableInput(input.name)"
                    @select="value => {filter(input.name, value, input.multiple)}"
                    @remove="value => {filter(input.name, value, input.multiple, true)}"
                    @search-change="query => {debounceGetSelectOptions(input.options_url, input.name, input.filter_field, query)}"
                    select-label=""
                    selected-label=""
                    deselect-label="X ">
                  <template slot="noResult">
                    {{$t('global.no_results')}}
                  </template>
                </multiselect>

              </b-col>

              <b-col
                  :md="inputsWidth"
                  class=" flex-column mb-4"
                  v-for="(input, index) in groupSelects"
                  :key="`${index}${input.name}`"
              >
                <group-select
                    :input="input"
                    :model="filterObject[input.name]"
                    @select="filter"
                    @remove="filter"
                    :group-select="input.groupSelect"
                    :key="`grp-adv-${input.name}-${resetKey}`"
                />
              </b-col>

              <b-col
                  :md="inputsWidth"
                  class=" flex-column mb-4"
                  v-for="(input, index) in datepickers"
                  :key="`${index}${input.name}`"
              >

                <label
                    class="d-block"
                    v-if="input.label"
                >{{ input.label }}</label>


                <DatePickerInput
                    v-model="filterObject[input.name]"
                    :mode="input.mode"
                    @input="value => {normalizeDate(input.name, value)}"
                    :is-range="input.isRange"
                />

              </b-col>

              <b-col
                  :md="inputsWidth"
                  class=" flex-column d-flex justify-content-end mb-4"
                  v-for="(input, index) in checkboxes"
                  :key="`${index}${input.name}`"
              >
                <b-form-checkbox
                    v-model="filterObject[input.name]"
                    :disabled="disableInput(input.name)"
                    :value="input.value"
                    @input="value => {filter(input.name, value, input.multiple)}"
                > {{input.label}}
                </b-form-checkbox>
              </b-col>

            </b-row>
            <b-row class="mt-2">
              <b-col class="mb-4 d-flex justify-content-center">
                <b-button
                    variant="primary"
                    class="px-4 mr-2"
                    @click="applyFilters"
                    :disabled="filterActionsDisabled"
                >Apply</b-button>
                <b-button
                    variant="outline-primary"
                    class="px-4"
                    @click="clearAll"
                    :disabled="filterActionsDisabled"
                >Clear All</b-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {filter, forEach, isEmpty, isObject, pull, debounce, assign} from 'lodash';
import {Money} from 'v-money'
import DatePickerInput from "../forms/fields/datePickerInput";

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    inputs: {
      type: Array,
      required: true
    },
    limit: {
      type: Number,
      default: 10
    },
    extendButton: {
      type: Boolean,
      default: false
    },
    extended: {
      type: Boolean
    },
    globalFilter: {
      type: String,
      default: ''
    },
    inputsWidth: {
      type: Number,
      default: 4
    },
    filters: {
      type: Object,
      default: () => ({
        range: {
          from: '',
          to: ''
        }
      })
    },
    manualApply: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loader: false,
      filterObject: {
        range: {
          from: '',
          to: ''
        }
      },
      money: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      filterObjectMutated: {},
      selectOptions: {},
      extend: false,
      groupMultiselects: {},
      selectsReady: false,
      debounceGetSelectOptions: () => {
      },
      resetKey: 0
    }
  },
  components: {DatePickerInput, Money},
  mounted() {
    this.filterObject = this.filters;
    this.$forceUpdate();
    this.loader = this.loading;
    this.extend = this.extended;
    this.debounceFilter = debounce(this.filter, 500);
    this.debounceGetSelectOptions = debounce(this.getSelectOptions, 500);
    if (this.manualApply && this.filterObject) {
      this.syncMutatedFromFilterObject();
    }
  },
  computed: {
    mainInputs() {
      return filter(this.inputs, input => input.main);
    },
    secondaryInputs() {
      return filter(this.inputs, input => !input.main)
    },
    inputsText() {
      return filter(this.secondaryInputs, input => input.type === 'text');
    },
    checkboxes() {
      return filter(this.secondaryInputs, input => input.type === 'checkbox');
    },
    priceRanges() {
      return filter(this.secondaryInputs, input => input.type === 'price-range');
    },
    selects() {
      let selects = filter(this.secondaryInputs, input => input.type === 'select' && !input.group);

      forEach(selects, select => {
        if (!!select.options_url) {
          this.getSelectOptions(select.options_url, select.name)
        } else {
          this.selectOptions[select.name] = select.options;
        }
      });
      return selects
    },
    groupSelects() {
      return filter(this.secondaryInputs, input => input.type === 'select' && input.group);
    },
    datepickers() {
      return filter(this.secondaryInputs, input => input.type === 'date');
    },
    filterActionsDisabled() {
      const hasFilledValue = (value) => {
        if (value === null || value === undefined) {
          return false;
        }

        if (Array.isArray(value)) {
          return value.some(item => hasFilledValue(item));
        }

        if (typeof value === 'object') {
          if (Object.prototype.hasOwnProperty.call(value, 'start') || Object.prototype.hasOwnProperty.call(value, 'end')) {
            return hasFilledValue(value.start) || hasFilledValue(value.end);
          }

          return Object.values(value).some(item => hasFilledValue(item));
        }

        if (typeof value === 'string') {
          return value.trim() !== '';
        }

        if (typeof value === 'boolean') {
          return value === true;
        }

        if (typeof value === 'number') {
          return true;
        }

        return false;
      };

      const sources = [];

      if (this.filterObjectMutated) {
        sources.push(this.filterObjectMutated);
      }

      if (this.filterObject) {
        sources.push(this.filterObject);
      }

      if (!sources.length) {
        return true;
      }

      return !sources.some(source => hasFilledValue(source));
    }
  },
  methods: {
    // clearInput (e, object, field) {
    //   console.log(e)
    //   const input = e.target.offsetParent.parentElement.querySelector('input');
    //
    //   if (!!input.value) {
    //     object[field] = '';
    // this.debounceFilter(name, '')
    // }
    // },
    disableInput(field) {
      // Never disable the advanced filters toggle button
      if (field === 'button') {
        return false;
      }
      // Do not disable other fields even if global filter has a value
      return false
    },

    syncMutatedFromFilterObject() {
      this.filterObjectMutated = {};
      if (!this.filterObject) return;
      Object.keys(this.filterObject).forEach((key) => {
        if (key === 'range') return;
        const val = this.filterObject[key];
        if (val === undefined || val === null || val === '') return;
        this.filter(key, val);
      });
    },

    applyOnEnter(field) {
      if (!this.manualApply) return;
      const val = (this.filterObject && this.filterObject[field] != null) ? this.filterObject[field] : '';
      if (typeof val === 'string') {
        // Ensure latest value is reflected in mutated params immediately
        this.filter(field, val);
        this.applyFilters();
      }
    },

    filter(field, value, multiple = false, remove = false, range = false) {
      if (range) {
        value = value * 100;
        field = field.split(' ');
        let range = field[1];
        field = field[0];
        if (!this.filterObject.range.from && !this.filterObject.range.to) {
          value = ''
        } else if (range === 'from') {
          if (!!this.filterObject.range.to) {
            if (parseInt(value) > parseInt(this.filterObject.range.to * 100)) {
              value = `${this.filterObject.range.to * 100}-${value}`
            } else {
              value = `${value}-${this.filterObject.range.to * 100}`
            }
          } else {
            value = `${value}-`
          }
        } else if (range === 'to') {
          if (!!this.filterObject.range.from) {
            if (parseInt(value) < parseInt(this.filterObject.range.from * 100) && parseInt(value) !== 0) {
              value = `${value}-${this.filterObject.range.from * 100}`
            } else if (parseInt(value) === 0) {
              value = `${this.filterObject.range.from * 100}-`
            } else {
              value = `${this.filterObject.range.from * 100}-${value}`
            }
          } else {
            value = `-${value}`
          }
        }
        value = value === '-' ? '' : value
      }

      if (isObject(field)) {
        value = field.value;
        multiple = field.multiple || false;
        remove = field.remove || false;
        field = field.field;
      }

      if (isObject(value)) {
        if (Array.isArray(value)) {
          value = value.map(item => {
            return item.value
          })
        } else if (value.hasOwnProperty('value')) {
          value = value.value;
        }
      }
      this.emitParams(field, value, multiple, remove)

    },

    emitParams(field, value, multiple, remove) {
      let params = {};
      if (field === this.globalFilter && value !== '') {
        params[field] = value;
        this.filterObject = assign({}, params);
        this.filterObjectMutated = assign({}, params);
      } else {
        if (multiple) {
          if (!this.filterObjectMutated[field]) {
            this.$set(this.filterObjectMutated, field, [])
          }
          if (remove) {
            if(Array.isArray(value))
              for (let item of value) {
                this.filterObjectMutated[field] = _.filter(this.filterObjectMutated[field], (currentObject) => {
                  return currentObject.value !== item.value
                })
              } else {
              pull(this.filterObjectMutated[field], value);
            }

            if (isEmpty(this.filterObjectMutated[field])) {
              this.$delete(this.filterObjectMutated, field);
            }
          } else {
            if (Array.isArray(value)) {
              for (let item of value) {
                this.filterObjectMutated[field].push(item);
              }
            } else {
              this.filterObjectMutated[field].push(value);
            }
          }
        } else {
          if (value === '' || remove) {
            if (this.filterObject.hasOwnProperty(field)) {
              this.$delete(this.filterObject, field);
            }
            if (this.filterObjectMutated.hasOwnProperty(field)) {
              this.$delete(this.filterObjectMutated, field);
            }
          } else {
            this.$set(this.filterObjectMutated, field, value);
          }
        }
        params = this.filterObjectMutated;
      }

      if (!this.manualApply) {
        this.$emit('filter', params)
      }
    },

    applyFilters() {
      this.$emit('filter', this.filterObjectMutated)
    },

    clearAll() {
      // отменить ожидающие дебаунсы, чтобы они не перезаписали очищенные значения
      if (this.debounceFilter && this.debounceFilter.cancel) this.debounceFilter.cancel();
      if (this.debounceGetSelectOptions && this.debounceGetSelectOptions.cancel) this.debounceGetSelectOptions.cancel();

      // очистить мутацию параметров
      this.filterObjectMutated = {};

      // собрать пустой объект фильтров, учитывая все типы инпутов
      const empty = { range: { from: '', to: '' } };
      (this.inputs || []).forEach((input) => {
        if (!input || !input.name) return;
        switch (input.type) {
          case 'text':
            this.$set(empty, input.name, '');
            break;
          case 'select':
            this.$set(empty, input.name, input.multiple ? [] : null);
            break;
          case 'date':
            this.$set(empty, input.name, null);
            break;
          case 'checkbox':
            this.$set(empty, input.name, false);
            break;
          case 'price-range':
            // уже покрыто в empty.range
            break;
          default:
            // по умолчанию удаляем значение
            this.$set(empty, input.name, null);
        }
      });

      // явно очистить глобальный фильтр, если он задан
      if (this.globalFilter) {
        this.$set(empty, this.globalFilter, '');
      }

      // применить пустой объект фильтров для реактивного сброса UI
      this.filterObject = empty;
      // форсируем перерендер group-select
      this.resetKey++;

      this.$nextTick(() => {
        this.$forceUpdate();
        this.$emit('filter', {});
      });
    },

    getSelectOptions(url, name, field = null, value = null) {
      const params = {filter: {}};
      if (value) {
        params.filter[field] = value
      }
      try {
        this.loader = true;
        if (url === 'countries') {
          this.getCountries(url, {params}).then(({data}) => {
            if (data && data.items) {
              this.$set(this.selectOptions, name, data.items.map(option => {
                if (option.title) {
                  return {
                    label: option.title,
                    value: option.title
                  }
                }
              }))
            }
          })
        } else {
          this.getData(url, {params}).then(({data}) => {
            if (data && data.items) {
              this.selectOptions[name] = data.items.map(option => {
                if (option.name && option.id) {
                  return {
                    label: option.name,
                    value: option.id
                  }
                } else if (option.slug && option.title) {
                  return {
                    label: option.title,
                    value: option.slug
                  }
                } else if (option.slug && !option.title) {
                  return {
                    label: option.slug,
                    value: option.slug
                  }
                } else if (option.title) {
                  return {
                    label: option.title,
                    value: option.title
                  }
                } else if (option.key) {
                  return {
                    label: option.key,
                    value: option.id
                  }
                }
              });
              this.$forceUpdate();
            }
          })
        }

      } catch (e) {
        console.log(e)
      } finally {
        this.loader = false;
      }
    },
    normalizeDate(field, value) {
      if (value instanceof Date) {
        value = this.formatDate(value, 'L');
        this.filter(field, value)
      } else if (!value) {
        this.filter(field, '');
      } else if (isObject(value)) {
        switch (field) {
          case 'userplanrelationships.created_at':
            this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
            break;

          case 'userplanrelationships.subscription_end_date':
            this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
            break;

          case 'transactions.created_at':
            this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
            break;

          case 'content.created_at':
            this.filter(field, `${this.formatDate(value.start, 'L')}-${this.formatDate(value.end, 'L')}`);
            break;

        }
      }
    },

    getDatePickerPlaceholder (isRange, isDateTime) {
      return isRange ? `MM/DD/YYYY ${isDateTime ? 'hh:mm' : ''}- MM/DD/YYYY ${isDateTime ? 'hh:mm' : ''}` : `MM/DD/YYYY ${isDateTime ? 'hh:mm' : ''}`
    }
  },
  watch: {
    loading(value) {
      this.loader = value
    },
    extended(val) {
      this.extend = val
    },
    filters(val) {
      this.filterObject = val;
      if (this.manualApply) {
        this.syncMutatedFromFilterObject();
      }
    }
  }
}

</script>
